import e, { useState as w, useMemo as E } from "react";
import c from "./index270.mjs";
import { useClientDetails as I } from "./index149.mjs";
import { useSalesTermsShow as y, useTermsAndConditionsShow as v, useSalesTermsAndConditions as P } from "./index102.mjs";
import { useAtomValue as o, useSetAtom as k } from "jotai";
import "@amenitiz/design-system";
import { roomsAvailabilityAtom as N } from "./index34.mjs";
import { selectedClientDetailsAtom as B } from "./index55.mjs";
import { getConfigPropertyAtomCreator as D, ConfigProperty as F } from "./index13.mjs";
import { setCurrentStepAtom as R } from "./index25.mjs";
import { Button as V } from "./index82.mjs";
import { PaymentType as l } from "./index232.mjs";
import { Banner as u } from "./index142.mjs";
import f from "./index210.mjs";
import { calculateTotalPrice as H } from "./index111.mjs";
import { formatPrice as p } from "./index110.mjs";
import { TosElement as M } from "@amenitiz/payment-frontend";
const te = ({
  cartItems: d,
  giftCards: _,
  paymentType: r
}) => {
  const { setShowSalesTerms: C } = y(), { setShowTermsAndConditions: A } = v(), { salesTermsAndConditions: t } = P(), { setClientDetails: n } = I(), i = o(B), S = k(R), [h, s] = w(!0), a = H({ cartItems: d, giftCards: _ }), b = o(
    E(() => D(F.HOTEL_NAME), [])
  ), m = o(N), T = () => r === l.CASH ? /* @__PURE__ */ e.createElement(
    u,
    {
      title: I18n.t("booking_engine.information.cash_info", {
        price: p(
          parseFloat(a),
          m.currency
        ),
        hotel_name: b
      }),
      Icon: f,
      onClose: () => s(!1),
      permanent: !0
    }
  ) : r === l.BANK_TRANSFER ? /* @__PURE__ */ e.createElement(
    u,
    {
      variation: "warning",
      title: I18n.t("booking_engine.information.bank_transfer_info", {
        price: p(
          parseFloat(a),
          m.currency
        )
      }),
      Icon: f,
      onClose: () => s(!1),
      permanent: !0
    }
  ) : null;
  return /* @__PURE__ */ e.createElement("div", { className: c["without-cc-form"], "data-testid": "without-cc-form" }, h ? T() : null, /* @__PURE__ */ e.createElement(
    M,
    {
      setTncAccepted: (g) => {
        n({
          sales_terms_accepted: g
        });
      },
      tncAccepted: i.sales_terms_accepted || !1,
      showSalesTerms: () => C(!0),
      showTermsAndConditions: t != null && t.terms_and_conditions ? () => A(!0) : void 0
    }
  ), /* @__PURE__ */ e.createElement(
    V,
    {
      disabled: !i.sales_terms_accepted,
      label: I18n.t("booking_engine.information.continue"),
      dataTestId: "without-cc-continue",
      classes: c.continue,
      onClick: () => {
        n({
          sales_terms_accepted: !0
        }), S(3);
      }
    }
  ));
};
export {
  te as WithoutCardContainer
};
